import { ICustomTheme } from 'interfaces';

export const skipDisabledPropOption = {
  shouldForwardProp: (prop: string) => prop !== 'isDisabled',
};

export const getMainColor = (theme: ICustomTheme, isDisabled?: boolean) =>
  isDisabled ? theme.colors.grey.light : theme.colors.paletteFromBO.main;
